import { createSlice, PayloadAction } from '@reduxjs/toolkit'

type UserType = {
    id: number
    username: string
    role: "admin" | "staff"
}

type AuthState = {
    accessToken: string | null
    user: UserType | null
    isAuth?: boolean
    isLoading?: boolean
}

const initialState: AuthState = {
    accessToken: null,
    user: null,
    isAuth: false,
    isLoading: true,
}

export const authSlice = createSlice({
    name: 'auth',
    initialState,
    reducers: {
        setAuth(state, action: PayloadAction<AuthState>) {
            state.accessToken = action.payload.accessToken
            state.user = action.payload.user
            state.isAuth = action.payload.isAuth
            state.isLoading = false
        },
        clearAuth(state) {
            state.accessToken = null
            state.user = null
            state.isAuth = false
            state.isLoading = false
        },
        setLoading: (state, action) => {
            state.isLoading = action.payload
        }
    },
})

export const {
    setAuth,
    clearAuth,
    setLoading,
} = authSlice.actions
